<button (click)="addNewOpertion()" type="button" class="mx-0 btn btn-outline-primary btn-lg btn-block mt-4 mb-2">
  {{'ADD' |translate}}
  <i class="fa fa-plus fa-1x icons-style" aria-hidden="true" placement="left" ngbTooltip="{{ 'ADD' | translate }}"></i>
</button>
<div class="ui-widget-header search-area row">
  <div class="col-4">
    <label>{{translate.currentLang == 'ar' ? 'بحث' : 'Search' }}

    </label>

    <input #gb type="text" class="form-control mt-2 mb-1" pInputText size="30" placeholder="{{ 'FILTER' | translate }}">
  </div>
  <div class="col-8">
    <app-fast-search [preventDefault]="false" [appearFastSearch]="false" name="fastSearchData" [appCodes]="[796]"
      (searchKeys)="onSearchClick($event)" ngDefaultControl></app-fast-search>
  </div>
  <!-- <div class="col-2">
    <label>{{translate.currentLang == 'ar' ? 'لدية خصم' : 'Have Discount' }}</label>
    <input type="checkbox" [checked]="cheackDiscount == true" [(ngModel)]="cheackDiscount" #check
      (change)="filter()" />
  </div> -->
</div>
<p-dataTable class="table table-responsive" tableStyleClass="table table-bordered table-striped"
  [value]=" inTransferBodiesList" [selectionMode]="'single'" [rows]="10"
   [paginator]="true" [pageLinks]="3"
  [rowsPerPageOptions]="[5,10,20,50,100]" [globalFilter]="gb">
  <p-column field="serial" header="{{'CODE' | translate}}" [sortable]="true"></p-column>
  <p-column field="nameAr" header="{{'ARABICNAME' | translate }}">
    <ng-template pTemplate="options" let-row="rowData">
      <input *ngIf="row.Status==2 || row.Status ==1" type="text" class="form-control" [(ngModel)]="row.nameAr" />
      <b *ngIf="!row.Status || row.Status==4">{{row.nameAr}}</b>
    </ng-template>
  </p-column>
  <p-column field="nameEn" header="{{'ENGLISHNAME' | translate}}" [sortable]="true">
    <ng-template pTemplate="options" let-row="rowData">
      <input *ngIf="row.Status==2 || row.Status ==1" type="text" class="form-control" [(ngModel)]="row.nameEn" />
      <b *ngIf="!row.Status || row.Status==4">{{row.nameEn}}</b>
    </ng-template>
  </p-column>

  <p-column field="address" header="{{'ADDress' | translate}}" [sortable]="true">
    <ng-template pTemplate="options" let-row="rowData">
      <input *ngIf="row.Status==2 || row.Status ==1" type="text" class="form-control" [(ngModel)]="row.address" />
      <b *ngIf="!row.Status || row.Status==4">{{row.address}}</b>
    </ng-template>
  </p-column>
  <p-column field="speciality" header="{{'Speciality' | translate}}" [sortable]="true">
    <ng-template pTemplate="options" let-row="rowData">
      <input *ngIf="row.Status==2 || row.Status ==1" type="text" class="form-control" [(ngModel)]="row.speciality" />
      <b *ngIf="!row.Status || row.Status==4">{{row.speciality}}</b>
    </ng-template>
  </p-column>
  <p-column [style]="{'width': '10%'}" field="accountNo" header="{{'ACCOUNTNUMBER' | translate}}"
  [sortable]="true">
  <ng-template pTemplate="options" let-row="rowData">
    <sanabel-selectize *ngIf="row.Status==2 || row.Status ==1" appcode="1003" [simpleView]="true"
      [(ngModel)]="row.accountNo">
    </sanabel-selectize>
    <b *ngIf="!row.Status || row.Status==4">
      {{translate.currentLang == 'ar' ? row.accountNameAr : row.accountNameEn}}
    </b>
  </ng-template>
</p-column>
  <!-- <p-column field="feesRate" header="{{'feesRate' | translate}}" [sortable]="true">
    <ng-template pTemplate="options" let-row="rowData">
      <input *ngIf="row.Status==2 || row.Status ==1" type="text" class="form-control"
        [(ngModel)]="row.feesRate" />
      <b *ngIf="!row.Status || row.Status==4">{{row.feesRate}}</b>
    </ng-template>
  </p-column> -->
  <p-column [style]="{'width': '5%'}" header="{{ 'STATUS' | translate }}">
    <ng-template pTemplate="options" let-row="rowData">
      <input *ngIf="row.Status==2 || row.Status ==1" type="checkbox" class="form-control"
        [(ngModel)]="row['rowStatus']" />
      <i *ngIf="!row.Status || row.Status==4" class="fa" style="font-size: 20px" [ngClass]="{'fa-check': row.rowStatus == 1,'fa-times': row.rowStatus !=1
        ,'approve-check': row.rowStatus == 1,'dis-approve-check': row.rowStatus !=1}">
      </i>
    </ng-template>
  </p-column>
  <p-column field="discountValue" header="{{'CFDISCOUNTPERCENT' | translate}}" [sortable]="true">
    <ng-template pTemplate="options" let-row="rowData">
      <input *ngIf="row.Status==2 || row.Status ==1" type="text" class="form-control" [(ngModel)]="row.discountValue" />
      <b *ngIf="!row.Status || row.Status==4">{{row.discountValue}}</b>
    </ng-template>
  </p-column>

  <p-column [style]="{'width': '5%'}" field="percentOrValue" header="{{'PERCENTORVALUE' | translate}}"
    [sortable]="true">
    <ng-template pTemplate="options" let-row="rowData">
      <sanabel-selectize *ngIf="row.Status==2 || row.Status ==1" appcode="40" [simpleView]="true"
        [(ngModel)]="row.percentOrValue">
      </sanabel-selectize>
      <b *ngIf="!row.Status || row.Status==4">
        {{translate.currentLang == 'ar' ? row.percentOrValueAr : row.percentOrValueEn}}
      </b>
    </ng-template>
  </p-column>

  <p-column [style]="{'width': '10%'}" field="cshDiscountsCode" header="{{'DiscountDiscription' | translate}}"
    [sortable]="true">
    <ng-template pTemplate="options" let-row="rowData">
      <sanabel-selectize *ngIf="row.Status==2 || row.Status ==1" appcode="1053" [simpleView]="true"
        [(ngModel)]="row.cshDiscountsCode">
      </sanabel-selectize>
      <b *ngIf="!row.Status || row.Status==4">{{translate.currentLang == 'ar' ? row.cshDiscountsAr :
        row.cshDiscountsEn}}</b>
    </ng-template>
  </p-column>

  <p-column [style]="{'width': '8%'}" header="{{ 'CONFIRMEDBY' | translate }}" [sortable]="true">
    <ng-template pTemplate="options" let-row="rowData">
      <div *ngIf="!row.Status || row.Status==4">{{row.confirmedByAr}}
        <br>
        {{(row['confirmDate']) | date:'dd/MM/yyyy'}}
      </div>
    </ng-template>
  </p-column>

  <p-column [style]="{'width': '5%'}" styleClass="col-button">
    <ng-template pTemplate="options" let-row="rowData">
      <icon-action *ngIf="!row.Status || row.Status==4" (clicked)="onRowIconClick($event , row)"
        [appCodes]="[402,403,7064,7067]"></icon-action>
      <div *ngIf="row.Status==2">
        <button class="btn btn-info btn-sm" (click)="undoAddEdit(row, 2);">
          <i class="fa fa-undo fa-1x"></i>
        </button>
        <button class="btn btn-success btn-sm" (click)="save(row);">
          <i class="fa fa-save fa-1x"></i>
        </button>
      </div>
      <div *ngIf="row.Status == 1">
        <button class="btn btn-info btn-sm" (click)="undoAddEdit(row, 1);">
          <i class="fa fa-undo fa-1x"></i>
        </button>
      </div>
    </ng-template>

  </p-column>
</p-dataTable>

<div class="row">
  <div class="col text-center">
    <!-- <button class="btn btn-success" (click)="save()"> save</button> -->
    <!-- [disabled]="DoctorsFeesClaim.length == 0"  -->
    <btns-ctrl #btnCtrl [appCodes]="[1]" [disabled]="disabled == 0" (clicked)="onBtnClicked($event)"></btns-ctrl>
  </div>
</div>
<div>
  <block-modal-container #newComingFrom>
    <ng-container class="modal-body" [ngComponentOutlet]="dynamicComponent"></ng-container>
  </block-modal-container>
</div>
